import Vue from 'vue'
import App from './App'
import 'amfe-flexible'
import router from './router'
import  VueResource  from 'vue-resource'


//引入组件
import { Badge,Button,Cell,CellGroup,Field,NavBar,Notify,Sticky,Search,Tab, Tabs,Tabbar,TabbarItem,Tag,Calendar,DropdownMenu, DropdownItem,Picker,Checkbox, CheckboxGroup,Grid, GridItem,DatetimePicker,Dialog,Radio,RadioGroup       } from 'vant'
import { Image as VanImage} from 'vant'
import { Form } from 'vant';
import { Divider } from 'vant';
import { NoticeBar } from 'vant';
import { Toast } from 'vant';
import { Icon } from 'vant';
import { ActionSheet } from 'vant';
import { Popup } from 'vant';
import { Col, Row } from 'vant';
import { ContactList,List } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Empty } from 'vant';
import { PullRefresh } from 'vant';
import { Uploader } from 'vant';

//导入组件
Vue.use(VueResource)
Vue.use(Popup);
Vue.use(ActionSheet);
Vue.use(Divider);
Vue.use(Form);
Vue.use(Button);
Vue.use(Cell);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(NoticeBar);
Vue.use(CellGroup);
Vue.use(Notify);
Vue.use(Icon).use(Col).use(Row).use(VanImage).use(ContactList).use(Toast).use(List).use(Sticky).use(Search).use(Tab).use(Tabs).use(TabbarItem).use(Tabbar)
.use(Tag).use(Calendar).use(DropdownMenu).use(DropdownItem).use(Picker).use(Checkbox).use(CheckboxGroup).use(Grid).use(GridItem).use(DatetimePicker).use(Dialog).use(Swipe)
.use(SwipeItem).use(Empty).use(PullRefresh).use(Uploader).use(Badge).use(Radio ).use(RadioGroup);


Vue.config.productionTip = false

new Vue({
  el:'#app',
  router,
  render: h => h(App)
})
